enum RewardCollection {
	hideout_rewards = 'hideout_rewards',
	daycare_staking = 'daycare_staking',
}

export default RewardCollection;
